import { gql, useQuery } from "@apollo/client";
import {
    PlatformContact,
    ViewPlatformContactQueryQuery,
    ViewPlatformContactQueryQueryVariables
} from "../../../../../../schemaTypes";

export const viewPlatformContactQuery = gql`
    query ViewPlatformContactQuery(
        $id: String!
    ) {
        viewPlatformContact(
            id: $id
        ) {
            id
            facebook
            x
            linkedin
            instagram
            logoUrl
            email
            website
            address
            updatedAt
            createdAt
        }
    }
`;

export function useViewPlatformContact(id: string) {
    const { data, loading, error } = useQuery<
        ViewPlatformContactQueryQuery,
        ViewPlatformContactQueryQueryVariables
    >(viewPlatformContactQuery, {
        variables: { id },
        skip: !id
    });

    return {
        platformContact: data?.viewPlatformContact as PlatformContact | undefined,
        loading,
        error
    };
}
